import { faClock as regClock } from '@fortawesome/pro-regular-svg-icons';
import { faClock as solidClock } from '@fortawesome/pro-solid-svg-icons';
import {
    ICorporationResponse,
    ITimeRangeResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { sdClient } from 'contexts/SDKClientContext';
import { useUpdateCorporationTimeRange } from 'custom_hooks/data_hooks/corporation/useUpdateCorporationTimeRange';
import { CorporationsTableCellProps } from 'pages/Settings/Corporations/CorporationsTable';
import { CorporationTimeRangeModal } from 'pages/Settings/Corporations/CorporationTimeRangesModal';
import { useState } from 'react';
import { KCFColor } from 'styles/themes/KCFColor';

export function EditCorporationTimeRangeCell({
    rowData,
    onChange,
}: CorporationsTableCellProps) {
    const [timeRangeModalOpen, setTimeRangeModalOpen] = useState(false);
    const [
        selectedCorporation,
        setSelectedCorporation,
    ] = useState<ICorporationResponse | null>();

    const { mutateAsync: updateTimeRanges } = useUpdateCorporationTimeRange({
        queryName: 'corporations-table',
    });

    const onSave = async (timeRanges: ITimeRangeResponse[]) => {
        try {
            await updateTimeRanges({
                corporationId: rowData.Id,
                body: {
                    TimeRangeIds: timeRanges.map((timeRange) => timeRange.Id),
                },
            });
            setTimeRangeModalOpen(false);
            onChange(await sdClient.getCorporation({ id: rowData.Id }));
        } catch {
            return 'Unable to save time ranges for corporation';
        }
        return undefined;
    };

    return (
        <>
            <HoverIconButton
                icon={regClock}
                hoverIcon={solidClock}
                color={KCFColor.secondaryText}
                title="Edit corporation's time ranges"
                onClick={() => {
                    setSelectedCorporation(rowData);
                    setTimeRangeModalOpen(true);
                }}
            />
            {selectedCorporation && timeRangeModalOpen && (
                <CorporationTimeRangeModal
                    corporation={selectedCorporation}
                    onClose={() => setTimeRangeModalOpen(false)}
                    onConfirm={onSave}
                />
            )}
        </>
    );
}
